import { ReactElement } from 'react'
import { LoadingIndicator } from '@ui/feedback'
import useGlobalLoadsQueryParams from '../../../../hooks/useGlobalLoadsQueryParams'
import WindLoadsForm from '../WindLoadsForm'

interface Props {
  data?: WindLoadsFormValues
  isLoading: boolean
  isSaving: boolean
  onSave: (data: WindLoadsFormValues) => void

  onSaveManualWindLoads: (data: WindloadResults) => void
  isLoadingManualWindLoads: boolean
  isSavingManualWindLoads: boolean
  ignoredSlabs?: string[]
}

const WindLoads = ({
  data,
  isLoading,
  isSaving,
  onSave,
  onSaveManualWindLoads,
  isLoadingManualWindLoads,
  isSavingManualWindLoads,
  ignoredSlabs = [],
}: Props): ReactElement => {
  const {
    params: { activeRoofAssignmentTab },
    actions: { setActiveWindAngle },
  } = useGlobalLoadsQueryParams()

  if (isLoading || !data) return <LoadingIndicator />

  return (
    <>
      <WindLoadsForm
        id="windloads-form"
        onSubmit={onSave}
        defaultValues={data}
        wallAssignmentParamsActions={{
          activeWindAngle: activeRoofAssignmentTab,
          setWindAngle: setActiveWindAngle,
        }}
        isLoading={isLoading}
        isSaving={isSaving}
        onSubmitManualWindLoads={onSaveManualWindLoads}
        isLoadingManualWindLoads={isLoadingManualWindLoads}
        isSavingManualWindLoads={isSavingManualWindLoads}
        ignoredSlabs={ignoredSlabs}
      />
    </>
  )
}

export default WindLoads
